/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListQuestionnaireResponseQuestionsResponse,
  ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams,
  ListQuestionnaireResponsesResponseV2,
  ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams,
  ListQuestionnairesResponse,
  ListQuestionnairesV2QuestionnairesGetParams,
  Questionnaire,
  QuestionnaireResponseNextQuestionResponse,
  QuestionnaireResponseQuestionResponse,
  QuestionnaireResponseV2,
  ResponseSubmitResult,
  StartQuestionnaireInput,
  StartQuestionnaireResponse,
  SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams,
  UpdateQuestionnaireResponseAnswerInput
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Returns a list of questionnaires filtered by actor permissions.
- Members can see all questionnaires
- Anonymous sessions can only see quizlet
 * @summary List Questionnaires
 */
export const listQuestionnairesV2QuestionnairesGet = (
    params?: ListQuestionnairesV2QuestionnairesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ListQuestionnairesResponse>(
      {url: `/v2/questionnaires`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListQuestionnairesV2QuestionnairesGetQueryKey = (params?: ListQuestionnairesV2QuestionnairesGetParams,) => {
    return [`/v2/questionnaires`, ...(params ? [params]: [])] as const;
    }

    
export const getListQuestionnairesV2QuestionnairesGetQueryOptions = <TData = Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError = HTTPValidationError>(params?: ListQuestionnairesV2QuestionnairesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionnairesV2QuestionnairesGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>> = ({ signal }) => listQuestionnairesV2QuestionnairesGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListQuestionnairesV2QuestionnairesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>>
export type ListQuestionnairesV2QuestionnairesGetQueryError = HTTPValidationError


export function useListQuestionnairesV2QuestionnairesGet<TData = Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError = HTTPValidationError>(
 params: undefined |  ListQuestionnairesV2QuestionnairesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnairesV2QuestionnairesGet<TData = Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError = HTTPValidationError>(
 params?: ListQuestionnairesV2QuestionnairesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnairesV2QuestionnairesGet<TData = Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError = HTTPValidationError>(
 params?: ListQuestionnairesV2QuestionnairesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Questionnaires
 */

export function useListQuestionnairesV2QuestionnairesGet<TData = Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError = HTTPValidationError>(
 params?: ListQuestionnairesV2QuestionnairesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnairesV2QuestionnairesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListQuestionnairesV2QuestionnairesGetQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns a single questionnaire and its questions or a 404 if the specified questionnaire does not exist.
- Members can access all questionnaires
- Anonymous sessions can only access quizlet
 * @summary Get Questionnaire By Id
 */
export const getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet = (
    questionnaireId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<Questionnaire>(
      {url: `/v2/questionnaires/${questionnaireId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryKey = (questionnaireId?: string,) => {
    return [`/v2/questionnaires/${questionnaireId}`] as const;
    }

    
export const getGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError = HTTPValidationError>(questionnaireId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryKey(questionnaireId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>> = ({ signal }) => getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet(questionnaireId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>>
export type GetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryError = HTTPValidationError


export function useGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet<TData = Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError = HTTPValidationError>(
 questionnaireId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet<TData = Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError = HTTPValidationError>(
 questionnaireId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet<TData = Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError = HTTPValidationError>(
 questionnaireId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Questionnaire By Id
 */

export function useGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet<TData = Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError = HTTPValidationError>(
 questionnaireId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireByIdV2QuestionnairesQuestionnaireIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuestionnaireByIdV2QuestionnairesQuestionnaireIdGetQueryOptions(questionnaireId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Starts a new questionnaire response.
Creates a new response record in the database and returns the response id and first question.

- Members can start any questionnaire
- Anonymous sessions can only start 'quizlet' questionnaire
 * @summary Start Questionnaire Response
 */
export const startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost = (
    questionnaireId: string,
    startQuestionnaireInput: StartQuestionnaireInput,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<StartQuestionnaireResponse>(
      {url: `/v2/questionnaires/${questionnaireId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startQuestionnaireInput, signal
    },
      );
    }
  


export const getStartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>, TError,{questionnaireId: string;data: StartQuestionnaireInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>, TError,{questionnaireId: string;data: StartQuestionnaireInput}, TContext> => {

const mutationKey = ['startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>, {questionnaireId: string;data: StartQuestionnaireInput}> = (props) => {
          const {questionnaireId,data} = props ?? {};

          return  startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost(questionnaireId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPostMutationResult = NonNullable<Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>>
    export type StartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPostMutationBody = StartQuestionnaireInput
    export type StartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPostMutationError = HTTPValidationError

    /**
 * @summary Start Questionnaire Response
 */
export const useStartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>, TError,{questionnaireId: string;data: StartQuestionnaireInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPost>>,
        TError,
        {questionnaireId: string;data: StartQuestionnaireInput},
        TContext
      > => {

      const mutationOptions = getStartQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns a list of all responses for the user, omits the items in the response.
Supports both members and anonymous sessions through actor-based authentication.
 * @summary List Questionnaire Responses
 */
export const listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet = (
    questionnaireId: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ListQuestionnaireResponsesResponseV2>(
      {url: `/v2/questionnaires/${questionnaireId}/responses`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryKey = (questionnaireId?: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams,) => {
    return [`/v2/questionnaires/${questionnaireId}/responses`, ...(params ? [params]: [])] as const;
    }

    
export const getListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryOptions = <TData = Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError = HTTPValidationError>(questionnaireId: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryKey(questionnaireId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>> = ({ signal }) => listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet(questionnaireId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>>
export type ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryError = HTTPValidationError


export function useListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    params: undefined |  ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Questionnaire Responses
 */

export function useListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    params?: ListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListQuestionnaireResponsesV2QuestionnairesQuestionnaireIdResponsesGetQueryOptions(questionnaireId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Records the answer to the current question and returns the next question.
Supports both members and anonymous sessions through actor-based authentication.
 * @summary Update Questionnaire Response Answer
 */
export const updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut = (
    questionnaireId: string,
    responseId: string,
    questionSlug: string,
    updateQuestionnaireResponseAnswerInput: UpdateQuestionnaireResponseAnswerInput,
 ) => {
      
      
      return customCatchBackendFetcher<QuestionnaireResponseNextQuestionResponse>(
      {url: `/v2/questionnaires/${questionnaireId}/responses/${responseId}/questions/${questionSlug}/answers`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateQuestionnaireResponseAnswerInput
    },
      );
    }
  


export const getUpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>, TError,{questionnaireId: string;responseId: string;questionSlug: string;data: UpdateQuestionnaireResponseAnswerInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>, TError,{questionnaireId: string;responseId: string;questionSlug: string;data: UpdateQuestionnaireResponseAnswerInput}, TContext> => {

const mutationKey = ['updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>, {questionnaireId: string;responseId: string;questionSlug: string;data: UpdateQuestionnaireResponseAnswerInput}> = (props) => {
          const {questionnaireId,responseId,questionSlug,data} = props ?? {};

          return  updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut(questionnaireId,responseId,questionSlug,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>>
    export type UpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPutMutationBody = UpdateQuestionnaireResponseAnswerInput
    export type UpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPutMutationError = HTTPValidationError

    /**
 * @summary Update Questionnaire Response Answer
 */
export const useUpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>, TError,{questionnaireId: string;responseId: string;questionSlug: string;data: UpdateQuestionnaireResponseAnswerInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPut>>,
        TError,
        {questionnaireId: string;responseId: string;questionSlug: string;data: UpdateQuestionnaireResponseAnswerInput},
        TContext
      > => {

      const mutationOptions = getUpdateQuestionnaireResponseAnswerV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugAnswersPutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Lists the questions for the questionnaire associated with the response.
If current is true, returns the current question for the response only.

- Members can access their own responses
- Anonymous sessions can access their own responses
 * @summary List Questionnaire Response Questions
 */
export const listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet = (
    questionnaireId: string,
    responseId: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<ListQuestionnaireResponseQuestionsResponse>(
      {url: `/v2/questionnaires/${questionnaireId}/responses/${responseId}/questions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryKey = (questionnaireId?: string,
    responseId?: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams,) => {
    return [`/v2/questionnaires/${questionnaireId}/responses/${responseId}/questions`, ...(params ? [params]: [])] as const;
    }

    
export const getListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryOptions = <TData = Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError = HTTPValidationError>(questionnaireId: string,
    responseId: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryKey(questionnaireId,responseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>> = ({ signal }) => listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet(questionnaireId,responseId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId && responseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>>
export type ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryError = HTTPValidationError


export function useListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    params: undefined |  ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>,
          TError,
          Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Questionnaire Response Questions
 */

export function useListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet<TData = Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    params?: ListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListQuestionnaireResponseQuestionsV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsGetQueryOptions(questionnaireId,responseId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a specific question with navigation context and current answer.

Returns the question details, current answer (if any), and conditional-aware
navigation slugs for previous/next questions.

- Members can access their own responses
- Anonymous sessions can access their own responses
 * @summary Get Questionnaire Response Question
 */
export const getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet = (
    questionnaireId: string,
    responseId: string,
    questionSlug: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<QuestionnaireResponseQuestionResponse>(
      {url: `/v2/questionnaires/${questionnaireId}/responses/${responseId}/questions/${questionSlug}`, method: 'GET', signal
    },
      );
    }
  

export const getGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryKey = (questionnaireId?: string,
    responseId?: string,
    questionSlug?: string,) => {
    return [`/v2/questionnaires/${questionnaireId}/responses/${responseId}/questions/${questionSlug}`] as const;
    }

    
export const getGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError = HTTPValidationError>(questionnaireId: string,
    responseId: string,
    questionSlug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryKey(questionnaireId,responseId,questionSlug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>> = ({ signal }) => getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet(questionnaireId,responseId,questionSlug, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId && responseId && questionSlug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>>
export type GetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryError = HTTPValidationError


export function useGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    questionSlug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    questionSlug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    questionSlug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Questionnaire Response Question
 */

export function useGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string,
    questionSlug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuestionnaireResponseQuestionV2QuestionnairesQuestionnaireIdResponsesResponseIdQuestionsQuestionSlugGetQueryOptions(questionnaireId,responseId,questionSlug,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a questionnaire response with all submitted answers.
Returns the complete response including all answer values.

- Members can access their own responses
- Anonymous sessions can access their own responses
 * @summary Get Questionnaire Response With Answers
 */
export const getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet = (
    questionnaireId: string,
    responseId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<QuestionnaireResponseV2>(
      {url: `/v2/questionnaires/${questionnaireId}/responses/${responseId}/answers`, method: 'GET', signal
    },
      );
    }
  

export const getGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryKey = (questionnaireId?: string,
    responseId?: string,) => {
    return [`/v2/questionnaires/${questionnaireId}/responses/${responseId}/answers`] as const;
    }

    
export const getGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryOptions = <TData = Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError = HTTPValidationError>(questionnaireId: string,
    responseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryKey(questionnaireId,responseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>> = ({ signal }) => getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet(questionnaireId,responseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(questionnaireId && responseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryResult = NonNullable<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>>
export type GetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryError = HTTPValidationError


export function useGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>,
          TError,
          Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Questionnaire Response With Answers
 */

export function useGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet<TData = Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError = HTTPValidationError>(
 questionnaireId: string,
    responseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetQuestionnaireResponseWithAnswersV2QuestionnairesQuestionnaireIdResponsesResponseIdAnswersGetQueryOptions(questionnaireId,responseId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Submits or transitions a questionnaire response.

Actions:
- status='submit' (default): Moves status from in-progress/editing to completed
  - Also triggers risk calculation for cancer-risk-assessment questionnaires (members only)
- status='edit': Transitions a completed questionnaire to editing status
  - Allows users to modify previously submitted responses

- Members: Can submit or edit their responses
- Anonymous sessions: Can submit (no risk calculation for quizlet)
 * @summary Submit Questionnaire Response
 */
export const submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch = (
    questionnaireId: string,
    responseId: string,
    params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams,
 ) => {
      
      
      return customCatchBackendFetcher<ResponseSubmitResult>(
      {url: `/v2/questionnaires/${questionnaireId}/responses/${responseId}`, method: 'PATCH',
        params
    },
      );
    }
  


export const getSubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>, TError,{questionnaireId: string;responseId: string;params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>, TError,{questionnaireId: string;responseId: string;params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams}, TContext> => {

const mutationKey = ['submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>, {questionnaireId: string;responseId: string;params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams}> = (props) => {
          const {questionnaireId,responseId,params} = props ?? {};

          return  submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch(questionnaireId,responseId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>>
    
    export type SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchMutationError = HTTPValidationError

    /**
 * @summary Submit Questionnaire Response
 */
export const useSubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>, TError,{questionnaireId: string;responseId: string;params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatch>>,
        TError,
        {questionnaireId: string;responseId: string;params?: SubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchParams},
        TContext
      > => {

      const mutationOptions = getSubmitQuestionnaireResponseV2QuestionnairesQuestionnaireIdResponsesResponseIdPatchMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    